import type { ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'
import { Link } from '@tanstack/react-router'

import { Button } from '@gto/ui/button'
import { CheckCircleIcon } from '@gto/ui/icons/solid'
import { Paper } from '@gto/ui/paper'
import { gradients } from '@gto/ui/theme/design-tokens'
import { Typography } from '@gto/ui/typography'

import { AbsoluteSuitsOnCorners } from '@/components/absolute-suits-on-corners'
import { sendGaEvent } from '@/gtag'
import type { Translations } from '@/localise'

export const RbWizardPros = () => {
  return (
    <section
      className="relative mt-12 flex flex-col items-center gap-16 rounded-md border border-divider px-8 py-12 sm:items-stretch sm:gap-12 sm:px-4"
      style={{
        background: gradients.primary.horizontal(0.01, 0.08),
      }}
    >
      <AbsoluteSuitsOnCorners top={-4} />
      <div className="text-center">
        <Typography
          gutterBottom
          className="whitespace-pre-line"
          color="primary"
          component="h2"
          variant="h3"
        >
          <FormattedMessage id="home.rbwizardPros.title" />
        </Typography>
        <Typography
          className="font-semibold"
          color="text.primary"
          component="h2"
          variant="h6"
        >
          <FormattedMessage id="home.rbwizardPros.description" />
        </Typography>
      </div>
      <div className="flex justify-center gap-6 md:flex-col">
        {Array(3)
          .fill(null)
          .map((_, index) => (
            <ProsCard
              // eslint-disable-next-line @eslint-react/no-array-index-key -- fixed 3-card render, never reorders
              key={index}
              title={
                <FormattedMessage
                  id={`home.rbwizardPros.pros.${index + 1}.title` as keyof Translations}
                />
              }
            />
          ))}
      </div>
      <div>
        <Button
          className="sm:w-full"
          color="primary"
          component={Link}
          href="/app/deals"
          size="large"
          variant="contained"
          onClick={() => {
            sendGaEvent({
              event: 'home_get_rewarded',
            })
          }}
        >
          <FormattedMessage id="common.controls.getRewarded" />
        </Button>
      </div>
    </section>
  )
}

const ProsCard = ({ title }: { title: string | ReactNode }) => {
  return (
    <Paper className="max-w-[25%] rounded-md border border-divider bg-[#1B1B1CCC] px-6 py-4 md:max-w-full">
      <div className="flex items-start gap-3">
        <div className="flex-[0_0_auto] text-primary-main">
          <CheckCircleIcon
            color="inherit"
            height={36}
          />
        </div>
        <Typography
          className="text-left"
          variant="body2"
        >
          {title}
        </Typography>
      </div>
    </Paper>
  )
}
